class FriendsScreenController {

    constructor() {
        this.template = Handlebars.compile($("#worldFriendsScreen").html());
        this.menuTemplate = Handlebars.compile($("#fullModalMenu").html());
        this.isModal = false;
        this.isChallenge = false;   // Para el listado de retos que es diferente
        this.hasToRemovePreviousModal = false;
        this.hasToRemoveChatProfileStack = false;
        this.allUsers = [];
        this.subsegments = [];
        this.segments = [];
        this.currentSegment = {};   // Para buscar solo dentro de ese segmento
        this.friendsCustomization = {};
        this.slideActionsFriendList = new SlideActionsFriendList();

        let that = this;

        $(window).resize(function () {
            that.showHideHorizontalScrollBtn();
        });

        $(document).on('keyup', '.friends-search-bar-input', (e) => {
            if (e.keyCode == 13) {
                this.filterFriendsList(that.isChallenge ? "challenge" : "friends");
            }
        });

        $(document).on('click', '.friends-search-bar-btn', (e) => {
            this.filterFriendsList(that.isChallenge ? "challenge" : "friends");
        });

        // Para el scroll de los segmentos
        $(document).on('click', '#segment-slide-left', function (e) {
            const scrollLeft = $('.segment-list');
            let scroll = scrollLeft.scrollLeft();
            scrollLeft.scrollLeft(scroll-40);
        });

        $(document).on('click', '#segment-slide-right', function (e) {
            const scrollRight = $('.segment-list');
            let scroll = scrollRight.scrollLeft();
            scrollRight.scrollLeft(scroll+80);
            scrollRight.animate({ "left": "+=80px" }, "slow" );
        });

        // Mostrar el listado de subsegmentos
        $(document).on('click', '.segment-option', function (e) {
            $('.segment-option-selected').removeClass('segment-option-selected');
            $(this).addClass('segment-option-selected');

            let search = $('.friends-search-bar-input').val();
            that.currentSegment = $(this).data('id');

            if(!that.currentSegment) {
                that.drawUsersList(that.allFriends, that.isChallenge ? 'challenge' : 'friends');
                return false;
            }

            let isSubsegment = $('.segment-option-back').length > 0;
            if(isSubsegment) {
                api.getUsers(search, that.currentSegment, function (friends) {
                    that.drawUsersList(FriendsScreenController.formatUsers(friends), that.isChallenge ? 'challenge' : 'friends');
                });
            } else {
                api.getSubsegments(that.currentSegment, search, function (response) {
                    that.drawSegmentsList(response.result);
                    that.subsegments = response.result;
                });
            }
        });

        // Mostrar el listado de usuarios del subsegmento
        $(document).on('click', '.user-segment', function (e) {
            let search = $('.friends-search-bar-input').val();
            let segmentId = $('.segment-option.world_color_1_bg').data('id');
            that.currentSegment = $(this).data('id');

            api.getUsers(search, that.currentSegment, function (friends) {
                that.drawUsersList(FriendsScreenController.formatUsers(friends), that.isChallenge ? 'challenge' : 'friends');
                that.drawSegmentsMenu(that.subsegments, true);
                $('.segment-option-back').attr('data-segment', segmentId);
                $('.segment-option[data-id="' + that.currentSegment + '"]').addClass('world_color_1_bg');
            });
        });

        // Volver atrás
        $(document).on('click', '.segment-option-back', function (e) {
            that.currentSegment = $(this).data('segment');
            that.drawSegmentsList(that.subsegments);
            that.drawSegmentsMenu(that.segments);

            $('.segment-option.world_color_1_bg').removeClass('world_color_1_bg');
            $('.segment-option[data-id="' + that.currentSegment + '"]').addClass('world_color_1_bg');
        });

        // Llamar por telefono
        $(document).on('click', '#link-user-label-phone', function (e) {
            let phone = $(this).data('phone');
            window.open('tel:' + phone);
            return false;
        });

        // Enviar email
        $(document).on('click', '#link-user-label-email', function (e) {
            let email = $(this).data('email');
            window.open('mailto:' + email);
            return false;
        });
    }

    filterFriendsList(friendsListType) {

        var inputValue = $('.friends-search-bar-input').val();
        let that = this;
        let usersList = $('#friendsList').is(':visible');
        let segmentsList = $('#subsegmentsList').is(':visible');

        if (usersList) {
            api.getUsers(inputValue, that.currentSegment, function (friends) {
                worldHomeController.friends = _.map(friends, 'friend');
                that.drawUsersList(FriendsScreenController.formatUsers(friends), friendsListType);
            });
        }

        if (segmentsList) {
            api.getSubsegments(that.currentSegment, inputValue, function (response) {
                that.drawSegmentsList(response.result);
            });
        }
    }

    // Para el listado de amigos/chat/ranking
    draw(context, isChallenge, isModal = false, modalTitle = false) {
        let tabs = new Tabs();
        let that = this;
        this.isModal = isModal;
        this.isChallenge = isChallenge;
        this.currentSegment = null;

        if (isModal && this.hasToRemovePreviousModal) {
            this.hasToRemovePreviousModal = false;
            baseController.closeSimpleMenu();
        } else if(!isModal) {
            baseController.resetStackableOrder();
            baseController.drawMainMenu(tabs.AMIGOS_TAB);
        }

        context.friend_icon = world.theme.friend_icon;
        context.fight_icon = world.theme.fight_icon;
        context.world = world;

        this.allFriends = FriendsScreenController.formatUsers(context.friends);

        that.friendsCustomization = baseController.userCustomization();
        that.segments = that.friendsCustomization.visible_categories;

        context.friendsCustomization = that.friendsCustomization;
        context.segments = that.segments;

        if(isModal) {   // Dibujar la modal
            baseController.resetStackableOrder();
            let title = modalTitle ? modalTitle : 'TR_SELECCIONA_OPONENTE';
            baseController.stackSimpleMenu({ title: title, icon: 'back' }, that.menuTemplate);
            baseController.stackSimpleContent(that.template, context, 'GAME');
        } else {    // Dibujar la screen
            let html = this.template(context);
            $("#jugar").html(html);
        }

        if(context.segments.length > 0) {
            that.drawSegmentsMenu(context.segments);
        }
        that.drawUsersList(that.allFriends, isChallenge ? 'challenge' : 'friends');
    }

    // Pintar el listado con los usuarios filtrados o todos
    drawUsersList(friends, type='friends') {
        let fragmentTemplate = Handlebars.compile($('#friendsListFragment').html());
        $('#friendsList').html(fragmentTemplate({
            world: world,
            friends: friends,
            type: type,
            friendsCustomization: this.friendsCustomization,
            showBtn: world.world_allow_challenges,
            currentUserId: user.id,
            enabledSlideButton: true
        }));
        FriendsScreenController.focusSearchInput();

        $("#friendsList").show();
        $("#subsegmentsList").hide();
        $('.friends-search-bar-btn').attr('data-type', type);
        rankingScreenController.adaptDivToContentRankingUsersList();

        this.tintImage();

        $("#friends-list-fragment").off().on("click.openFriendProfile", ".friend-item.is-directory", function(event) {
            event.preventDefault();
            event.stopPropagation();
            api.getUserProfile(world.token, $(this).data("user"), false);
        });

        this.slideActionsFriendList.initialize();

    }

    // Pintar el listado de subsegmentos
    drawSegmentsList(segments) {
        let fragmentTemplate = Handlebars.compile($('#subsegmentsListFragment').html());
        $("#subsegmentsList").html(fragmentTemplate({subsegments: segments}));

        $("#friendsList").hide();
        $("#subsegmentsList").show();

        this.tintImage();
    }

    // Pintar la barra superior de segmentos y subsegmentos
    drawSegmentsMenu(segments, backBtn = false) {
        let textColor = world.theme.login_text_color;
        let segmentBackground = hex2rgba(world.theme.color_3, 0.5);
        let fragmentTemplate = Handlebars.compile($('#segmentsMenuFragment').html());
        $("#segmentsMenu").html(fragmentTemplate({segments: segments, backBtn: backBtn}));
        $('#chevron-back-subsegment').attr('data-color', textColor);
        $('#segment-menu-bar').css('background-color', segmentBackground);

        this.showHideHorizontalScrollBtn();
        this.tintImage();
    }

    static focusSearchInput() {
        let searchInput = $('.friends-search-bar-input');

        // Multiply by 2 to ensure the cursor always ends up at the end;
        // Opera sometimes sees a carriage return as 2 characters.
        let strLength = searchInput.val().length * 2;

        searchInput.focus();
        searchInput[0].setSelectionRange(strLength, strLength);
    }

    //Quitar el friends intermedio
    static formatUsers(users) {
        let friends = [];

        users.forEach(function (item) {
            let user = item.friend;
            user.icon = user.user_icon;
            user.level_color = user.level ? user.level.color : null;
            user.level_icon = user.level ? user.level.icon : null;
            user.level = user.user_rank;
            user.user_points = user.user_points ? formatValueByLocale(user.user_points) : 0;
            friends.push(item.friend);
        });

        return friends;
    }

    tintImage() {
        $(".tintedCanvas").each(function () {
            tintImage($(this).attr('id'), $(this).attr('data-icon'), $(this).attr('data-color'));
        });
    }

    showHideHorizontalScrollBtn() {
        // Ocultar/mostrar los botones del scroll horizontal
        if($('.segment-list').length === 0)
            return;

        if($('.segment-list').get(0).scrollWidth === $('.segment-list').outerWidth()) {
            $('#segment-slide-left').hide();
            $('#segment-slide-right').hide();
        } else {
            $('#segment-slide-left').show();
            $('#segment-slide-right').show();
        }
    }
}
